import React from 'react'
import utils from './utils'
import parser from '../../../../services/parser.services'

function getLevelLayout(gameContainerWidth, gameContainerHeight, settings, quantities, answer, large = false) {

    const width = gameContainerWidth
    const fontSize = width / 6
    const height = gameContainerHeight
    const marginTop = height / 2 

    return (
        <span className="level-text-html" style={{fontSize: fontSize}}>{parser.parseQuestion(settings.question, quantities, answer)}</span>
    )
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/numberWords.utils.js